/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-04-15 00:00:00
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, TextStyle, Banner, Stack, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';

type State = {
  activeInfoBanner: boolean
};

type Props = {
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

class ShopifyCurrentLimitations extends Component<ComposedProps, State> {
  state = {
    activeInfoBanner: true
  };

  componentDidMount() {
    // Check show info banner
    let dismiss = false;
    try {
      dismiss = localStorage.getItem(`${getShop()}-dismissShopifyCurrentLimitationsBanner`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismiss === 'true') {
      this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
    }
  }

  render() {
    const { activeInfoBanner } = this.state;
    const { emailSupport, i18n } = this.props;
    return (
      activeInfoBanner && (
        <Layout.Section>
          <Banner
            title={i18n.translate('AdminHTML.Sync.ShopifyCurrentLimitations.bannerTitle')}
            status="info"
            onDismiss={this.handleDismissInfoBanner}>
            <Stack>
              <TextStyle>
                {i18n.translate('AdminHTML.Sync.ShopifyCurrentLimitations.text1', {
                  t1: (
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Sync.ShopifyCurrentLimitations.text1_t1')}
                    </TextStyle>
                  ),
                  t2: (
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Sync.ShopifyCurrentLimitations.text1_t2')}
                    </TextStyle>
                  ),
                  t3: (
                    <Link external url={URL.PresentmentPricesNotUpdated}>
                      {i18n.translate('AdminHTML.Sync.ShopifyCurrentLimitations.text1_t3')}
                    </Link>
                  ),
                  t4: (
                    <Link external url={URL.MultipleCurrenciesLimitation}>
                      {i18n.translate('AdminHTML.Sync.ShopifyCurrentLimitations.text1_t4')}
                    </Link>
                  )
                })}
              </TextStyle>
              <TextStyle>
                {i18n.translate('AdminHTML.Sync.ShopifyCurrentLimitations.text2', {
                  nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
                })}{' '}
              </TextStyle>
            </Stack>
          </Banner>
        </Layout.Section>
      )
    );
  }

  // Handle dismiss info banner
  handleDismissInfoBanner = () => {
    try {
      localStorage.setItem(`${getShop()}-dismissShopifyCurrentLimitationsBanner`, 'true');
    } catch (error) {}
    this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
  };
}

const mapStateToProps = state => ({
  emailSupport: _.get(state.oauth, 'emailSupport')
});

export default connect(mapStateToProps)(withI18n()(ShopifyCurrentLimitations));
